import React from 'react';
import styled from 'styled-components';

import { colors } from 'Constants';

function hexToRgb(hex, alpha) {
  
  
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const triangle = () => (
  <svg className="triangle" height="20" width="20">
    <polygon points="0,0 10,10 20,0" />
  </svg>
);

const TriangleIcon = styled(triangle)`
  fill: ${props => props.color};
`;

const Table = styled.table`
  border-collapse: collapse;
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  tr {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.2)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.2)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.2)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.2)};
    }
  }

  tr:nth-child(2n) {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.3)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.3)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.3)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.3)};
    }
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: transparent;
    }

    th:nth-child(3n + 2) {
      background-color: #1355e9
      color: ${"#ffffff"};
      font-family: Elevance Sans Semibold;
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
      color: ${colors.textOnAccent};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
      color: ${colors.textOnAccent};
    }
  }

  .row:nth-child(even) {
    background-color: #e2f2f2;
  }
`;

export default props => (
  <Table color1="#c8c8c8" color2="#c8c8c8">
    <tbody>
      <tr>
        {props.headers.map((val, i) => (
          <th key={i}>{val}</th>
        ))}
      </tr>
      {props.rows.map(row => (
        <tr>
          {row.map(val => (
            <td>{val}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </Table>
);
